export const reactDnDItemTypes = {
  TERMCONTENT: "termContent",
};
